















































































import { Vue, Component, Mixins } from 'vue-property-decorator';

import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {
    row: any = {}

    mounted() {
      this.$store.dispatch('users/vipcarddetail', {
        id: this.editId,
      }).then((res) => {
        this.row = res.Data;
      });
    }
}
